import { render, staticRenderFns } from "./puDetail.vue?vue&type=template&id=5179a982"
import script from "./puDetail.vue?vue&type=script&lang=js"
export * from "./puDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports